import React from "react";
import "./Home.css"
import Banner from "../Banner/Banner";
import Summary from "../Summary/Summary";
import {
  MdProductionQuantityLimits,
  MdAccessibilityNew,
  MdDry,
  MdReviews,
} from "react-icons/md";
import FAQ from "../FAQ/FAQ";
import Subscribe from "../Subscribe/Subscribe";
import HomeProducts from "../HomeProducts/HomeProducts";
import Reviews from "../Swiper/Reviews";
import Partners from "../Partners/Partners";
import Services from "../service/Services";
import Quotes from "../QuickQuote/Quotes";
import SoluationGuide from "../soluation_guide/SoluationGuide";

const Home = () => {
  return (
    <div className="home-container">
      <Banner></Banner>
      <div className="my-5">
        <h1 className="text-center text-lg-start container font-ita  text-muted mb-5 fw-bold">Featured Products</h1>
        <HomeProducts></HomeProducts>
      </div>
      <div className="container-fluid nav-bg">

        <div className="d-flex flex-lg-row flex-column rounded-pill justify-content-evenly">
          {companyProfile.map((profile) => (
            <Summary key={profile.id} profile={profile} />
          ))}
        </div>

      </div>

      <div className="my-5 container">

        <Partners></Partners>
      </div>
      <div className="my-5 px-lg-4">
        <h1 className="text-center text-muted mb-5 fw-bold font-ita">
          What Our Happy Client Says
        </h1>
        <Reviews></Reviews>
      </div>



      <div className="my-5 container-fluid">
        <Services></Services>

      </div>
      <div className="my-5 container-fluid nav-bg ">
        <SoluationGuide></SoluationGuide>

      </div>
      <div className="my-5 container">
        <Quotes></Quotes>

      </div>
    </div>
  );
};
const companyProfile = [
  {
    id: 1,
    title: "Total Product",
    count: 50,
    prifex: "k",
    dis: "In the Inventory",
    icons: <MdProductionQuantityLimits />,
  },
  {
    id: 2,
    title: "Happy Client",
    count: 120,
    prifex: "k",
    dis: "All Over The World",
    icons: <MdAccessibilityNew />,
  },
  {
    id: 3,
    title: "Our Partner",
    count: 60,
    prifex: "K",
    dis: "Work With Us",
    icons: <MdDry />,
  },
  {
    id: 4,
    title: "Reviews",
    count: 7,
    prifex: "K",
    dis: "From Customer",
    icons: <MdReviews />,
  },
];

export default Home;
